import React from "react";
import styled, {keyframes} from "styled-components";
import {CardFan} from "./trivia/CardFan";
import {DILEMA_LOGO_URL} from "../dilemaLogoUrl";
import {SiteFooter, PageHeader, LargeTitle} from "../ui";
import {BentoGrid} from "../Bento";
import kartHero from "../img/kart-hero.webp";   // rendered from the game's own 3D kart model
import flightHero from "../img/flight-hero.webp";   // rendered from Dream Flight's own biplane model

const GAMES = () => [
    {
        key: 'flight', href: '/dream-flight/', eyebrow: 'חדש · טיסה', wide: true, tint: '#0f766e', title: 'Dream Flight', ltr: true,
        desc: 'טיסה לאורך הנהר',
        bg: `radial-gradient(120% 90% at 30% 0%, #a9d0ea 0%, #4b86b3 45%, #1b3a52 100%)`,
        art: <FlightArt src={flightHero} alt=""/>,
    },
    {
        key: 'kart', href: '/turbo-kart/', eyebrow: 'מרוץ', feature: true, tint: '#bf4800', title: "Miller's Kart", ltr: true,
        desc: 'מרוץ קארטינג בתלת־ממד · שני מסלולים · טבלת שיאים',
        blurb: 'תשעה נהגים, שני מסלולים, קפיצות, האצות ופריטים. בחרו נהג וצאו לדרך.',
        bg: `radial-gradient(120% 80% at 30% 0%, #7a2a1c 0%, #2a1410 60%, #0b0806 100%)`,
        art: <KartBox><KartArt src={kartHero} alt=""/><Smoke className="s1"/><Smoke className="s2"/><Smoke className="s3"/></KartBox>,
    },
    {
        key: 'pop', href: '/game/', eyebrow: 'ארקייד', wide: true, tint: '#2563eb', title: 'Miller Pop!', ltr: true,
        desc: 'מפוצצים בועות · טבלת שיאים',
        bg: `radial-gradient(120% 80% at 50% 0%, #26287a 0%, #0a0a2e 70%)`,
        art: <PopArt src="/game/Adv.png" alt=""/>,
    },
    {
        key: 'trivia', to: '/trivia', eyebrow: 'טריוויה', tint: '#7c3aed', title: 'טריוויה משפחתית',
        desc: 'כמה אתם מכירים את המשפחה?',
        bg: `radial-gradient(120% 80% at 50% 0%, #4b2a8a 0%, #1a0a2e 75%)`,
        art: <FanBox><CardFan size="large"/></FanBox>,
    },
    {
        key: 'dilema', to: '/dilema', eyebrow: 'מסיבה', tint: '#16a34a', title: 'דילמה',
        desc: 'בחר צד. תהיה מהיר. שלח לחברים.',
        bg: `radial-gradient(90% 70% at 20% 10%, rgba(34,197,94,.32), transparent 60%), radial-gradient(90% 70% at 80% 90%, rgba(239,68,68,.26), transparent 60%), #0b0b12`,
        art: <LogoArt src={DILEMA_LOGO_URL} alt=""/>,
    },
    {
        key: 'center', href: '/centerkids/', eyebrow: 'אקשן', tint: '#db2777', title: 'Center Kids', ltr: true,
        desc: 'יורקים מהקומה העליונה של הסנטר 🖤',
        bg: `radial-gradient(90% 70% at 20% 12%, rgba(255,79,158,.3), transparent 60%), radial-gradient(90% 70% at 80% 88%, rgba(155,123,212,.32), transparent 60%), #1f1530`,
        art: (
            <SvgArt viewBox="0 0 120 120" aria-hidden="true">
                <polygon points="60,4 70,26 92,12 88,38 114,38 94,54 116,68 90,70 98,94 74,82 70,108 60,86 50,108 46,82 22,94 30,70 4,68 26,54 6,38 32,38 28,12 50,26"
                         fill="#ff4f9e" stroke="#241a12" strokeWidth="3" strokeLinejoin="round"/>
                <path d="M60 26 C48 48 40 58 40 72 a20 20 0 0 0 40 0 C80 58 72 48 60 26 Z" fill="#4fc3f7" stroke="#241a12" strokeWidth="4" strokeLinejoin="round"/>
                <ellipse cx="52" cy="70" rx="5" ry="8" fill="rgba(255,255,255,0.85)" transform="rotate(-18 52 70)"/>
            </SvgArt>
        ),
    },
    {
        key: 'wheel', href: '/wheel/', eyebrow: 'מזל', tint: '#ca8a04', title: 'הגלגל של אורי',
        desc: 'סובבו ותראו מה יוצא',
        bg: `radial-gradient(90% 70% at 18% 12%, rgba(255,202,58,.24), transparent 60%), radial-gradient(90% 70% at 82% 88%, rgba(138,201,38,.18), transparent 60%), #1d1336`,
        art: (
            <WheelArt viewBox="0 0 100 100" aria-hidden="true">
                <g className="rotor">
                    <circle cx="50" cy="50" r="47.5" fill="#ffffff"/>
                    <path d="M50 50 L32.4 7.5 A46 46 0 0 1 67.6 7.5 Z" fill="#ff595e" stroke="#fff" strokeWidth="1.5"/>
                    <path d="M50 50 L67.6 7.5 A46 46 0 0 1 92.5 32.4 Z" fill="#ff924c" stroke="#fff" strokeWidth="1.5"/>
                    <path d="M50 50 L92.5 32.4 A46 46 0 0 1 92.5 67.6 Z" fill="#ffca3a" stroke="#fff" strokeWidth="1.5"/>
                    <path d="M50 50 L92.5 67.6 A46 46 0 0 1 67.6 92.5 Z" fill="#8ac926" stroke="#fff" strokeWidth="1.5"/>
                    <path d="M50 50 L67.6 92.5 A46 46 0 0 1 32.4 92.5 Z" fill="#52a675" stroke="#fff" strokeWidth="1.5"/>
                    <path d="M50 50 L32.4 92.5 A46 46 0 0 1 7.5 67.6 Z" fill="#1982c4" stroke="#fff" strokeWidth="1.5"/>
                    <path d="M50 50 L7.5 67.6 A46 46 0 0 1 7.5 32.4 Z" fill="#6a4c93" stroke="#fff" strokeWidth="1.5"/>
                    <path d="M50 50 L7.5 32.4 A46 46 0 0 1 32.4 7.5 Z" fill="#e056a0" stroke="#fff" strokeWidth="1.5"/>
                    <circle cx="50" cy="50" r="12.5" fill="#ffffff"/>
                    <circle cx="50" cy="50" r="6" fill="#ffca3a"/>
                </g>
                <path d="M43 0 L57 0 L50 14 Z" fill="#ff4f6d" stroke="#fff" strokeWidth="2"/>
            </WheelArt>
        ),
    },
];


// bento order: the newest game as a full-width banner, then the tall feature + 2×2 block, then the other banner
const ORDER = ['flight', 'kart', 'trivia', 'dilema', 'center', 'wheel', 'pop'];

export const Games = () => {
    const games = GAMES();
    const items = ORDER.map((k) => games.find((g) => g.key === k)).filter(Boolean).map((g) => ({
        ...g, wash: g.bg, external: !!g.href, cta: 'שחק',
    }));
    return (
        <div className="page page-games">
            <Wrap>
                <PageHeader><LargeTitle>משחקים</LargeTitle></PageHeader>
                <BentoGrid items={items}/>
                <SiteFooter/>
            </Wrap>
        </div>
    );
};

/* ------------------------------------------------------------------ styles */
export const Wrap = styled.div`
    width: 100%;
    max-width: 1120px;
    box-sizing: border-box;
    padding: 8px 16px 32px;
    direction: rtl;

    @media (min-width: 768px) {
        padding: 24px 32px 56px;
    }
`;

const PopArt = styled.img`
    width: 210px;
    max-width: 70%;
    height: auto;
    filter: drop-shadow(0 12px 18px rgba(0, 0, 0, 0.35));
`;

/* hover: the kart throws its rear out, skids, smokes the back tyres and straightens up */
const drift = keyframes`
    0%   { transform: none; }
    18%  { transform: translateX(-10px) rotate(-3deg); }
    42%  { transform: translateX(16px) rotate(-11deg) skewX(4deg); }
    64%  { transform: translateX(-4px) rotate(3deg); }
    82%  { transform: translateX(2px) rotate(-1deg); }
    100% { transform: none; }
`;
const puff = keyframes`
    0%   { opacity: 0; transform: translate(0, 0) scale(0.35); }
    25%  { opacity: 0.85; }
    100% { opacity: 0; transform: translate(46px, -18px) scale(1.7); }
`;

const KartBox = styled.span`
    position: relative;
    display: inline-flex;
`;

const KartArt = styled.img`
    position: relative;
    z-index: 1;
    width: 210px;
    max-width: 66vw;
    height: auto;
    filter: drop-shadow(0 16px 22px rgba(0, 0, 0, 0.35));
    transform-origin: 42% 70%;   /* pivot near the front axle so the rear swings out */

    @media (hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference) {
        a:hover & { animation: ${drift} 1150ms cubic-bezier(0.3, 0.7, 0.3, 1) both; }
    }
`;

const FlightArt = styled.img`
    width: 260px;
    max-width: 72vw;
    height: auto;
    filter: drop-shadow(0 18px 22px rgba(0, 0, 0, 0.32));
`;

/* tyre smoke behind the rear wheels (rear = right side of the render) */
const Smoke = styled.span`
    position: absolute;
    z-index: 0;
    width: 54px;
    height: 54px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.85) 0%, rgba(230, 230, 235, 0.45) 45%, transparent 70%);
    filter: blur(3px);
    opacity: 0;
    pointer-events: none;

    &.s1 { right: 2%;  bottom: 22%; }
    &.s2 { right: 14%; bottom: 8%;  width: 44px; height: 44px; }
    &.s3 { right: -4%; bottom: 34%; width: 38px; height: 38px; }

    @media (hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference) {
        a:hover &.s1 { animation: ${puff} 900ms ease-out 330ms both; }
        a:hover &.s2 { animation: ${puff} 1000ms ease-out 400ms both; }
        a:hover &.s3 { animation: ${puff} 850ms ease-out 470ms both; }
    }
`;

const FanBox = styled.div`
    transform: scale(0.92);
`;

const LogoArt = styled.img`
    width: 128px;
    height: auto;
    border-radius: 50%;
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.45);
`;

const SvgArt = styled.svg`
    width: 138px;
    height: 138px;
    filter: drop-shadow(0 10px 16px rgba(0, 0, 0, 0.45));
`;

const WheelArt = styled(SvgArt)`
    width: 156px;
    height: 156px;

    .rotor {
        transform-origin: 50% 50%;
        transition: transform 1400ms var(--ease);
    }
    @media (prefers-reduced-motion: reduce) {
        .rotor { transition: none; }
    }
`;

